<ng-content></ng-content>
<div class="target-direction-indicator"
  *ngIf="draggingOnItemElement"
  [ngClass]="draggingOnItemPositioned === 'right' ? 'positioned-right' : 'positioned-left'"
  [style.height.px]="draggingOnItemElement.element.clientHeight + 10"
  [style.width.px]="draggingOnItemElement.element.clientWidth + 10"
  [style.top.px]="draggingOnItemElement.element.offsetTop - 5"
  [style.left.px]="draggingOnItemElement.element.offsetLeft - 5"
></div>